import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Minus: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[21px] h-[20px] stroke-[1.6px]', className)}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3334 9.33301H16.5001C16.8683 9.33301 17.1667 9.63148 17.1667 9.99967C17.1667 10.3679 16.8683 10.6663 16.5001 10.6663H11.3334H10.0001H4.83341C4.46522 10.6663 4.16675 10.3679 4.16675 9.99967C4.16675 9.63148 4.46522 9.33301 4.83341 9.33301H10.0001H11.3334Z"
      fill="currentColor"
      strokeWidth="currentStrokWidth"
    />
  </svg>
);

export default Minus;
